import { useOrganizationId } from '@/hooks/useSwr';

import { PlansAndBillingPageComponentV2 } from './PlansAndBillingV2/PlansAndBillingPageComponentV2';
import { StatusModalProvider } from './utils/useStatusModals';

export function OrganizationPlansAndBilling() {
  const organizationId = useOrganizationId();
  return (
    <StatusModalProvider>
      <PlansAndBillingPageComponentV2 key={organizationId} />
    </StatusModalProvider>
  );
}
